import { useDashboard } from '../../context/DashboardContext';

const IconHome = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-[22px] h-[22px]">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12 11.204 3.045a1.125 1.125 0 0 1 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
  </svg>
);

const IconCalendar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-[22px] h-[22px]">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
  </svg>
);

const IconLeaf = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-[22px] h-[22px]">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c-4.97 0-9 4.03-9 9 0 4.97 4.03 9 9 9s9-4.03 9-9c0-4.97-4.03-9-9-9ZM3.6 9h16.8M3.6 15h16.8" />
  </svg>
);

const IconEllipsis = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-[22px] h-[22px]">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
  </svg>
);

const TABS = [
  { id: 'uebersicht',     label: 'Übersicht', Icon: IconHome,     dashboardTab: 'uebersicht' },
  { id: 'pflegekalender', label: 'Pflege',    Icon: IconCalendar, dashboardTab: 'pflegekalender' },
  { id: 'garten',         label: 'Garten',    Icon: IconLeaf,     dashboardTab: null },
  { id: 'mehr',           label: 'Mehr',      Icon: IconEllipsis, dashboardTab: null },
];

const BottomTabBar = () => {
  const { mobileTab, setMobileTab, setDashboardTab } = useDashboard();

  const handleTabClick = (tab) => {
    setMobileTab(tab.id);
    if (tab.dashboardTab) {
      setDashboardTab(tab.dashboardTab);
    }
  };

  return (
    <nav
      className="flex fixed bottom-0 left-0 right-0 h-[68px] bg-white border-t border-gray-200 z-40"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Hauptnavigation"
    >
      {TABS.map((tab) => {
        const active = mobileTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => handleTabClick(tab)}
            className={`flex-1 flex flex-col items-center justify-center gap-[3px] min-h-[44px] transition-colors ${
              active ? 'text-emerald-600' : 'text-gray-500'
            }`}
            aria-current={active ? 'page' : undefined}
            aria-label={tab.label}
            data-testid={`bottomtab-${tab.id}`}
          >
            <tab.Icon />
            <span className="text-[10px] font-medium leading-none">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomTabBar;
